// import './AlbumUploadStepsForm.scss';

import * as React from "react"
import { ReactSVG } from "react-svg";
import { map } from 'lodash';

import { Button, Form, FormInstance, Input, Image, Checkbox, Spin, message } from "antd";
import { ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons'; 

import Dragger from "antd/lib/upload/Dragger";
import AlbumApi from "../../../api-services/album-api.service";
import { AlbumMedium } from "../../../interfaces/album.interface";


const {Search} = Input;
const CheckboxGroup = Checkbox.Group;
const maxImageCount = 50;

const imageMultiple = require('@mdi/svg/svg/image-multiple.svg');


interface IAlbumUploadStepsFormProps {
  saved?: () => void;
}

interface IAlbumUploadStepsFormState {
  uploadedImages: AlbumMedium[];
  videos: AlbumMedium[];
  selectAll: boolean;
  selectedImages: number[];
  deleting: boolean;
  uploading: boolean;
  addingVideo: boolean;
}

class AlbumUploadStepsForm extends React.Component <IAlbumUploadStepsFormProps, IAlbumUploadStepsFormState> {

  albumApi = new AlbumApi;
  albumUploadForm = React.createRef<FormInstance>();
  albumId = parseInt(window.location.href.split("/").pop());


  componentDidMount(){
    this.setState({
      uploadedImages: [],
      videos: [],
      selectAll: false,
      selectedImages: [],
      deleting: false,
      uploading: false,
      addingVideo: false,
    });

    this.getMediums();
  }


  getMediums(){
    this.albumApi.getMediums(this.albumId)
        .then(mediums => {
          const images = mediums.filter(medium => medium.type == "image"),
                videos = mediums.filter(medium => medium.type == "video");

          this.setState({uploadedImages: images, videos: videos});
        });
  }

  onUploadChange = (info) => {
    if(info.file.status === "uploading"){
      this.setState({uploading: true})
    }

    if(info.file.status === "done"){
      var responseData = info.file?.response?.data?.attributes;
      const image:AlbumMedium = {
        id: responseData.id,
        imageUrl: responseData.image_url
      }
      
      this.setState(prevState => ({
        uploadedImages: [...prevState.uploadedImages, image],
        uploading: false
      }));
    }
  }


  onCheckAllChange(e){
    const allImages = map(this.state?.uploadedImages, "id");
    this.setState({selectAll: e.target.checked, selectedImages: e.target.checked ? allImages: [] });
  }

  onSelectImage(list){
    this.setState({selectedImages: list, selectAll: list.length == this.state?.selectedImages?.length});
  }

  deleteImages(){
    this.setState({deleting: true});
    const selectedImagesId = this.state?.selectedImages;

    this.albumApi.deleteMediums(selectedImagesId)
      .then(response => {
        this.setState(prevState => ({
          uploadedImages: prevState.uploadedImages.filter(image => !selectedImagesId.includes(image.id))
        }));
      })
      .catch(err=>{

      })
      .finally(()=>{
        this.setState({deleting: false, selectedImages: []});
      })
  }

  deleteVideo(videoId){
    this.albumApi.deleteMediums(videoId)
      .then(response => {
        this.setState(prevState => ({
          videos: prevState.videos.filter(video => video.id !== videoId)
        }));
      })
      .catch(err=>{

      });
  }


  beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error('Image must smaller than 5MB!');
    }
    return isJpgOrPng && isLt2M;
  }


  onAddVideo(videoUrl){
    this.setState({addingVideo: true});

    this.albumApi.addVideo(this.albumId, videoUrl)
      .then(videoResponse => {
        this.setState(prevState => ({
          videos: [...prevState.videos, videoResponse]
        }));
        this.albumUploadForm.current.resetFields();
      })
      .catch(err =>{

      })
      .finally(()=>{
        this.setState({addingVideo: false});
      })
  }

  prev(){
    window.location.href = '/business/dashboard/albums/new';
  }


  render() {

    return (
      <div className="AlbumUploadStepsForm">

        <div className="typo-subheading-2 typo-bold section-header">PHOTOS | {this.state?.uploadedImages?.length} OF {maxImageCount} IMAGES UPLOADED </div>
        <Dragger name="image" action={`/api/v1/albums/my/${this.albumId}/mediums`} multiple={true} showUploadList={false} accept="image/*" beforeUpload={this.beforeUpload}
          onChange={this.onUploadChange} maxCount={50} disabled={this.state?.uploading}>
          <div className="ant-upload-drag-icon">
            {<ReactSVG src={imageMultiple} />}
          </div>
          <p className="ant-upload-hint">Drag and Drop Files Here</p>
          <p className="ant-upload-hint">OR</p>
          <Button type="primary" size="large">Add Photos</Button>
        </Dragger>

        <div className="uploaded-images-header">
          <div className="typo-subheading-2 typo-bold">UPLOADED IMAGES</div>
          <div>
            <Checkbox onChange={(e)=>this.onCheckAllChange(e)} checked={this.state?.selectAll}>
              Select All
            </Checkbox>
            <Button type="default" size="large" className="bulk-delete-btn" loading={this.state?.deleting} onClick={()=>this.deleteImages()}>
              Delete ({this.state?.selectedImages?.length})
            </Button>
          </div>
        </div>

        <div className="uploaded-images">
          <Spin size="large" spinning={this.state?.uploading}>
            <CheckboxGroup value={this.state?.selectedImages} onChange={(list)=>this.onSelectImage(list)}>
              {
                this.state?.uploadedImages.map(image => {
                  return (
                      <Checkbox key={image.id} value={image.id}>
                        <Image width={150} height={150} src={image.imageUrl}
                          fallback="data:image/png;base64,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"
                        />
                      </Checkbox>
                  )
                })
              }
            </CheckboxGroup>
          </Spin>
        </div>

        <div className="typo-subheading-2 typo-bold section-header">VIDEOS</div>
        <Form ref={this.albumUploadForm}>
          <Form.Item name="videoUrl">
            <Search placeholder="Enter code or video url" allowClear loading={this.state?.addingVideo}
              enterButton="ADD VIDEO" size="large" onSearch={(val)=>this.onAddVideo(val)}/>
          </Form.Item>
        </Form>

        <div className="videos-preview">
          <Spin size="large" spinning={this.state?.addingVideo}>
            {
              this.state?.videos.map(video => {
                return (
                  <div key={video.id} className="video">
                    <Button type="primary" danger className="delete-video" icon={<DeleteOutlined />} onClick={()=>this.deleteVideo(video.id)}/>
                    <div dangerouslySetInnerHTML={{ __html: 
                      `<iframe width="200" height="200" src="${video.videoUrl}" title="Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                    }} />
                  </div>
                )
              })
            }
          </Spin>
        </div>

        <div className="typo-subheading-2 typo-bold section-header">&nbsp;</div>

        <div className="steps-action">
          <Button type="link" className="typo-bold" icon={<ArrowLeftOutlined />} onClick={()=>this.prev()}>Previous</Button>
          <Button type="primary" className="antd-mod typo-bold-2" size="large" onClick={()=>this.props?.saved()}>
            Submit
          </Button>
        </div>

      </div>
    );
  }
}

export default AlbumUploadStepsForm
